import { render } from "./Section_Loans.vue?vue&type=template&id=8c7c6350"
import script from "./Section_Loans.vue?vue&type=script&lang=js"
export * from "./Section_Loans.vue?vue&type=script&lang=js"

import "./Section_Loans.vue?vue&type=style&index=0&id=8c7c6350&lang=scss"
script.render = render

export default script